import React, { useEffect, useState } from "react";
import { api, eur } from "@/lib/api";
import { Sparkles } from "lucide-react";

function Row({ label, value }) {
  if (value === null || value === undefined || value === "") return null;
  return (
    <div className="flex justify-between text-sm border-b border-sand-200 py-1">
      <span className="text-ink-500">{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}

export default function CustomerInsights({ cid }) {
  const [i, setI] = useState(null);
  useEffect(() => {
    (async () => {
      try { const r = await api.get(`/admin/customers/${cid}/insights`); setI(r.data); }
      catch { setI(null); }
    })();
  }, [cid]);
  if (!i) return null;
  return (
    <section className="rounded-2xl border border-sand-300 bg-white p-4" data-testid="crm-insights">
      <h2 className="font-semibold mb-2 flex items-center gap-1"><Sparkles className="w-4 h-4" /> Insight cliente</h2>
      <div className="grid md:grid-cols-2 gap-x-6">
        <Row label="Spesa totale" value={eur(i.total_spent_cents)} />
        <Row label="Ordini" value={i.orders_count} />
        <Row label="Ticket medio" value={eur(i.avg_ticket_cents)} />
        <Row label="Giorni medi fra visite" value={i.avg_days_between_visits} />
        <Row label="Giorno preferito" value={i.preferred_dow} />
        <Row label="Fascia oraria" value={i.preferred_time_slot} />
        <Row label="Categoria top" value={i.top_category} />
        <Row label="Prodotto top" value={i.top_product ? `${i.top_product.name} · ${i.top_product.qty}×` : null} />
        <Row label="Cocktail preferito" value={i.top_cocktail ? `${i.top_cocktail.name}` : null} />
        <Row label="Vino preferito" value={i.top_wine ? `${i.top_wine.name}` : null} />
        <Row label="Postazione preferita" value={i.preferred_station ? `${i.preferred_station.name} (${i.preferred_station.type})` : null} />
      </div>
    </section>
  );
}

export function CustomerBanners({ customer }) {
  if (!customer) return null;
  const banners = [];
  if (customer.vip_effective) banners.push({ icon: "⭐", label: "Cliente VIP", cls: "bg-amber-50 border-amber-300 text-amber-900" });
  if (customer.stage === "fire") banners.push({ icon: "🔥", label: "Cliente molto abituale", cls: "bg-red-50 border-red-300 text-red-900" });
  if (customer.birthday_soon) banners.push({
    icon: "🎂",
    label: customer.birthday_soon.is_today ? "Compleanno oggi!" : `Compleanno tra ${customer.birthday_soon.days_until} gg`,
    cls: "bg-pink-50 border-pink-300 text-pink-900"
  });
  if (customer.marketing_state === "rejected") banners.push({ icon: "🚫", label: "Marketing negato", cls: "bg-red-50 border-red-300 text-red-900" });
  if ((customer.allergies || []).length > 0) banners.push({ icon: "🥜", label: `Allergie: ${customer.allergies.join(", ")}`, cls: "bg-yellow-50 border-yellow-300 text-yellow-900" });
  if (customer.recovery_status === "vip_recovery") banners.push({ icon: "🚨", label: "VIP da recuperare", cls: "bg-red-100 border-red-400 text-red-900 font-semibold" });
  else if (customer.recovery_status === "recovery") banners.push({ icon: "⚠", label: "Cliente da recuperare", cls: "bg-amber-100 border-amber-400 text-amber-900" });
  (customer.tags || []).forEach((t) => banners.push({ icon: null, label: t, cls: "bg-sand-100 border-sand-300 text-ink-800" }));
  if (banners.length === 0) return null;
  return (
    <section className="flex flex-wrap gap-2" data-testid="crm-banners">
      {banners.map((b, i) => (
        <span key={i} className={`rounded-full border px-3 py-1 text-xs ${b.cls}`}
              data-testid={`crm-banner-${(b.label || "").replace(/\s+/g, "-")}`}>
          {b.icon && <span className="mr-1">{b.icon}</span>}{b.label}
        </span>
      ))}
    </section>
  );
}
